import { render, staticRenderFns } from "./ExpertServicesTable.vue?vue&type=template&id=15cc8100&scoped=true&lang=pug"
import script from "./ExpertServicesTable.vue?vue&type=script&lang=ts"
export * from "./ExpertServicesTable.vue?vue&type=script&lang=ts"
import style0 from "./ExpertServicesTable.vue?vue&type=style&index=0&id=15cc8100&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cc8100",
  null
  
)

/* custom blocks */
import block0 from "./ServicesTable.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FComponents%2FTable%2FExpertServicesTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports